'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _pages = require('./pages');
































var _constants = require('./constants');






var _UnsubscribePage = require('./pages/UnsubscribePage/UnsubscribePage');var _UnsubscribePage2 = _interopRequireDefault(_UnsubscribePage);
var _UnsubscribeSMSPage = require('./pages/UnsubscribeSMSPage/UnsubscribeSMSPage');var _UnsubscribeSMSPage2 = _interopRequireDefault(_UnsubscribeSMSPage);
var _containers = require('./containers');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var possibleRoutes = ['foreign', 'about', 'articles', 'articles', 'contact', 'contact_us_realtor', 'vr_promotion', 'help', 'home_details', 'project_details', 'payment', 'payment-success', 'payment-error', 'privacy', 'professionals', 'professionals', 'projects', 'property_details', 'manage_properties', 'mobile_promotion', 'realtor', 'company', 'profile', 'property', 'publish', 'terms'];

var sections = (0, _constants.getSectionsNames)();
var optionTypes = (0, _constants.getOptionTypes)();

var renderProjects = function renderProjects(prop) {var
  route = prop.route;

  var notFound = _react2.default.createElement(_pages.NotFoundPage, prop);
  var parsedRoute = route.split('/').filter(function (item) {return !!item;});

  if (parsedRoute[0] && parsedRoute[0].length === 2) {
    var localeIsValid = _constants.language.supportedLanguages.includes(parsedRoute[0]);

    if (!localeIsValid) {
      return notFound;
    }
    parsedRoute.shift();
  }var

  section = parsedRoute[0],optionType = parsedRoute[1];
  var detailsPages = ['home_details', 'project_details'];

  var routeIsValid = section === 'projects';
  var isDetailsPage = detailsPages.includes(section);

  if (!section && !optionType) {
    return _react2.default.createElement(_pages.HomePage, prop);
  }

  if (!routeIsValid && possibleRoutes.includes(section) && !isDetailsPage) {
    return null;
  }

  if (!routeIsValid && !sections.includes(section) && !isDetailsPage) {
    return notFound;
  }

  return _react2.default.createElement(_pages.SearchResultsPage, prop);
};

var renderSearchPage = function renderSearchPage(prop) {var
  route = prop.route;
  var notFound = _react2.default.createElement(_pages.NotFoundPage, prop);
  var parsedRoute = route.split('/').filter(function (item) {return !!item;});

  if (parsedRoute[0] && parsedRoute[0].length === 2) {
    var localeIsValid = _constants.language.supportedLanguages.includes(parsedRoute[0]);

    if (!localeIsValid) {
      return notFound;
    }
    parsedRoute.shift();
  }var

  section = parsedRoute[0],optionType = parsedRoute[1];

  var sectionIsValid = sections.includes(section);
  var optionTypeIsValid = optionTypes.includes(optionType);

  var routeIsValid = sectionIsValid && optionTypeIsValid || section === 'projects';
  var possibleOptions = ['searches', 'edit', 'edit_company'];
  var detailsPages = ['home_details', 'project_details', 'company'];
  var isDetailsPage = detailsPages.includes(section);

  if (!section && !optionType) {
    return _react2.default.createElement(_pages.HomePage, prop);
  }

  if (!routeIsValid && possibleRoutes.includes(section) && !isDetailsPage) {
    if (optionType && !possibleOptions.includes(optionType)) {
      return notFound;
    }

    return null;
  }

  if (!routeIsValid && section === 'company') {
    return null;
  }

  if (!routeIsValid && !isDetailsPage) {
    return notFound;
  }

  return _react2.default.createElement(_pages.SearchResultsPage, prop);
};exports.default =

function () {return (
    /* Please keep routes in alphabetical order */

    _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)', component: _pages.App },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _pages.HomePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)' + _constants.ROUTES_PATHS.FOREIGN, component: _pages.ForeignPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)' + _constants.ROUTES_PATHS.FOREIGN + '/:country', component: _pages.ForeignPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/(:locale/)' + _constants.ROUTES_PATHS.FOREIGN + '/:country/' + _constants.ROUTES_ADDITIONAL.FOREIGN_SEARCH,
        component: _pages.ForeignPropertyPage }),

      _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _pages.AboutUsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)articles', component: _pages.ArticlesPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)articles/(:id)', component: _pages.SingleArticlePage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'contact', component: _pages.ContactUsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'contact_us_realtor', component: _pages.RealtorLandingPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'vr_promotion', component: _pages.HolomaxPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'help', component: _pages.HelpPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)home_details/(:id)', component: _pages.PropertyDetailsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)invitation_expired', component: _pages.InvitationExpiredPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)invite_staff/(:id)', component: _pages.InviteStaffPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)project_details/(:id)', component: _pages.ProjectDetailsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)payment', component: _pages.PaymentPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/payment-success', component: _pages.SuccessPublishPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/payment-error', component: _pages.FailPublishPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'privacy', component: _pages.PrivacyPolicyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals/broker', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals/broker/search', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals/realtors_association', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals/realtors_association/search', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)professionals/search', component: _pages.ProfessionalsPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)projects*', component: renderProjects }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)property_details/(:id)', component: _pages.PropertyDetailsNative }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)manage_properties', component: _pages.ManagePropertiesPage /* onEnter={isUserAuthorized} */ }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)mobile_promotion', component: _pages.MobilePromotionPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)realtor/:realtorId', component: _pages.RealtorPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)staff/:id(/:pid)', component: _pages.RealtorUserPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)company/:companyId(/:pid)', component: _pages.CompanyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/edit', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/searches', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/my_company', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/my_staff', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/leads', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/realtor_page', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/leads/(:id)', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/my_projects', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)profile/my_subscriptions', component: _pages.EditProfilePage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)property/edit', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)publish', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)foreign_publish', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)foreign_property/edit', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)project/edit', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)foreign_project/edit', component: _pages.PublishPropertyPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)sign-in', component: _pages.UserAuthenticationPage }),
      _react2.default.createElement(_reactRouter.Route, { path: '/(:locale/)sign-up', component: _pages.UserAuthenticationPage }),
      _react2.default.createElement(_reactRouter.Route, { path: 'terms', component: _pages.TermsOfUsePage }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/(:locale/)unsubscribe/:topicId/:userId',
        component: _UnsubscribePage2.default }),

      _react2.default.createElement(_reactRouter.Route, {
        path: '/(:locale/)unsubscribe_sms/:topicId',
        component: _UnsubscribeSMSPage2.default }),


      _react2.default.createElement(_reactRouter.Route, {
        path: '/(:locale/):section/:optionTypes*',
        component: renderSearchPage }),


      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _pages.NotFoundPage, status: 404 })));};



/* TODO: Research the multipart route solution */module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 3119
// module chunks = 0